import React from "react";

export interface FilterDialogContextType {
    okButton: boolean
    setOkButton: (state: boolean) => void
    allButtonStatus: AllButtonStatusTypes
    setAllButtonStatus: (state: AllButtonStatusTypes) => void
    onSelectAll: () => void
    setOnSelectAll: (fn: (() => void)) => void
}

export function testFilterDialogContext(): FilterDialogContextType {
    let scopeSelectAll = () => {};

    return {
        okButton: false,
        setOkButton: (state: boolean) => {
        },
        allButtonStatus: 'show',
        setAllButtonStatus: (state: AllButtonStatusTypes) => {
        },
        onSelectAll: () => {
            scopeSelectAll()
        },
        setOnSelectAll: (state: () => () => void) => {
            scopeSelectAll = state();
        }
    } as FilterDialogContextType;
}

export type AllButtonStatusTypes = 'show' | 'hide' | 'disable'

export const FilterDialogContext = React.createContext<FilterDialogContextType | undefined>(undefined)